<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg' }" :title="title")
    b-container(fluid)
      div.context
        b-form
          form-approval-request(:form="detail")

          b-form-group(
            content-cols-sm
            :label="$t('management_page.approval_opinion')"
            label-for="approval-kind"
            label-cols-sm="2"
            label-align-sm="left"
          ).align-items-start
            b-select#approval-kind.mb-2(
              size="sm"
              v-model="postForm.kind",
              :options="kindOptions",
              style="width: 200px"
            )
            template(v-if="postForm.kind === 0")
              b-form-textarea#approval-reason(v-model="postForm.react_reason")
    .modal-footer
      b-button(variant="primary" size="sm" @click="handleState(true)" pill) {{$t('approval')}}
      b-button(variant="danger" size="sm" @click="handleState(false)" pill) {{$t('reject-submit')}}
      b-button(variant="secondary" size="sm" @click="visible = false" pill) {{$t('cancel')}}
</template>

<script>
import { ManagementAPI, ApprovalMacroAPI } from "@/api"
import Dialogs from "@/components/mixins/dialog/index.vue"
import FormApprovalRequest from "./formApprovalRequest.vue"
import _ from "lodash"
import moment from "moment"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Dialogs,
    FormApprovalRequest,
  },
  watch: {
    show(newVal) {
      this.visible = newVal
      if (newVal) {
        this.kindOptions = [{ text: this.$t('manual_input'), value: 0 }]
        this.postForm.kind = 0
        this.detail = _.cloneDeep(this.form)
        this.detail.device_alias = `${this.detail.device_name} (${this.detail.manager_pri_ip})`
        this.detail.approver = `${this.detail.approver_name} (${this.detail.approver_id})`

        this.detail.start_time = moment(this.form.start_time).format("YYYY-MM-DD")
        this.detail.start_time_hour = moment(this.form.start_time).format("HH")
        this.detail.start_time_min = moment(this.form.start_time).format("mm")

        this.detail.end_time = moment(this.form.end_time).format("YYYY-MM-DD")
        this.detail.end_time_hour = moment(this.form.end_time).format("HH")
        this.detail.end_time_min = moment(this.form.end_time).format("mm")

        this.detail.proposal_time = moment(this.form.proposal_time).format("YYYY-MM-DD")
        this.detail.proposal_time_hour = moment(this.form.proposal_time).format("HH")
        this.detail.proposal_time_min = moment(this.form.proposal_time).format("mm")

        this.fetchOpinion()
      }
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
    "postForm.kind"(val) {
      this.postForm.react_reason = ""
      if (val !== 0) {
        this.postForm.react_reason = _.clone(_.find(this.kindOptions, { value: val }).text)
      }
      this.approvalDisabled = val !== 0
    },
  },
  data() {
    return {
      visible: false,
      kindOptions: [{ text: this.$t('manual_input'), value: 0 }],
      detail: {},
      postForm: {
        kind: 0,
        react_reason: "",
      },
      approvalDisabled: false,
    }
  },
  methods: {
    fetchOpinion() {
      const params = { request_type: 1 }
      ApprovalMacroAPI.get("", { params }).then(res => {
        res.data.objects.forEach(element => {
          this.kindOptions.push({ text: element.title, value: element.pk })
        })
      })
    },
    handleState(state) {
      const params = {
        request_type: "remote",
        device_pk: this.form.device_pk,
        registration_status: state ? 2 : 1,
        react_reason: this.postForm.react_reason,
        approval_pk: this.form.type_pk,
      }
      ManagementAPI.manager.put("approval", params).then(res => {
        this.visible = false
        this.$emit("complate")
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
